// import { User } from '@/models/User';
// import { Country } from "@/types/Country";
import IProduct from "@/models/protocols/IProduct";
import IUser from "@/models/protocols/IUser";
import { Cart } from "@/types/Cart";

const SET_PRODUCTS = (state: any, obj: IProduct[]) => {
  state.products = obj;
};

const SET_USER = (state: any, obj: IUser) => {
  state.user = obj;
};

const SET_CART = (state: any, obj: Cart) => {
  state.cart = obj;
};

const SET_REGIONS = (state: any, regions: any) => {
  state.regions = regions;
};

const SET_UNDER_MAINTENANCE = (state: any, underMaintenance: Boolean) => {
  state.underMaintenance = underMaintenance;
};

export default {
  SET_PRODUCTS,
  SET_USER,
  SET_REGIONS,
  SET_CART,
  SET_UNDER_MAINTENANCE,
};
